import * as React from 'react';
import { useEffect, useState } from 'react'
import { Avatar, Button, CssBaseline, TextField, FormControlLabel, Checkbox, Box, Typography, Container, } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslation } from 'react-i18next';
import { accessTokenName, login } from '../../API/auth';
import { useNavigate } from 'react-router-dom';
import {Alert, AlertTitle, Stack} from '@mui/material';

export const  DescriptionAlerts = () => {
  const { t } = useTranslation()
  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
       {t("wrong")} <strong>{t("usernameOrPassword")}!</strong>
      </Alert>
    </Stack>
  );
}


export default function SignIn() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [logAccess, setLogAccess] = useState<boolean>(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const data = new FormData(e.target as HTMLFormElement)
    if (await login(data)){
          setLogAccess(false)
      navigate('/dashboard')
    }
    else{
        setLogAccess(true)
  }
  };

  useEffect(() => {
    if (localStorage.getItem(accessTokenName))
      navigate('/dashboard')
  }, [navigate])

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {
          logAccess?<DescriptionAlerts/>:''
        }
        <Avatar sx={{ m: 1, bgcolor: 'main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {t('signIn')}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="username"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label={t('rememberMe')}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {t('signIn')}
          </Button>
        </Box>
      </Box>
    </Container>

  );
}